/** Reine Sprachauflösung (ohne React/API-Abhängigkeiten, daher isoliert testbar).
 *  Browser-Sprache = AUTO-DETECTION, Benutzersprache = PERSISTENT PREFERENCE,
 *  Mandantensprache = DEFAULT. Diese drei Konzepte werden nie vermischt. */
import { LOCALES, PLATFORM_FALLBACK } from "./translations";

const SUPPORTED = LOCALES.map((l) => l.locale);

/** Regionale Variante ("de-AT", "EN_us") auf eine unterstützte App-Sprache normalisieren. */
export function normalizeLang(tag) {
  if (!tag) return null;
  const base = String(tag).toLowerCase().replace("_", "-").split("-")[0];
  return SUPPORTED.includes(base) ? base : null;
}

/** Erste unterstützte Browser-Sprache; wird NIE am Benutzer gespeichert. */
export function browserLanguage(nav = typeof navigator !== "undefined" ? navigator : null) {
  const tags = (nav && (nav.languages?.length ? nav.languages : [nav.language])) || [];
  for (const tag of tags) {
    const l = normalizeLang(tag);
    if (l) return l;
  }
  return null;
}

/** Verbindliche Reihenfolge: Benutzerpräferenz -> Browser -> tenant.default_language -> de. */
export function resolveUserLocale({ userPreferred, browser, tenantDefault, allowed }) {
  const ok = (l) => l && SUPPORTED.includes(l) && (!allowed?.length || allowed.includes(l));
  for (const c of [userPreferred, browser, tenantDefault]) if (ok(c)) return c;
  return PLATFORM_FALLBACK;
}
